import React from "react";
import { Button, CircularProgress, Tooltip } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import { useTranslation } from "react-i18next";
import color from "../../../Constants/colors";
import { VoicesSyncStatus } from "../../../Models/voicesOverview";

interface Props {
  status: VoicesSyncStatus | undefined;
  onRefresh: () => void;
}

const formatTime = (value: string | null | undefined) =>
  value ? new Date(value).toLocaleString([], { dateStyle: "short", timeStyle: "short" }) : "–";

const VoicesSyncButton: React.FC<Props> = ({ status, onRefresh }) => {
  const { t } = useTranslation("voicesCommon");
  const running = !!status?.running;

  return (
    <Tooltip
      title={t("syncLastChecked", {
        status: formatTime(status?.status_checked_at),
        metrics: formatTime(status?.metrics_checked_at),
      })}
    >
      <span>
        <Button
          size="small"
          variant="outlined"
          startIcon={running ? <CircularProgress size={14} sx={{ color: color.orange600 }} /> : <SyncIcon />}
          disabled={running}
          onClick={onRefresh}
          sx={{
            textTransform: "none",
            color: color.orange600,
            borderColor: color.orange200,
            "&:hover": { borderColor: color.orange600, backgroundColor: color.orange50 },
            "&.Mui-disabled": { color: color.gray500, borderColor: color.gray200 },
          }}
        >
          {running ? t("syncRunning") : t("syncRefresh")}
        </Button>
      </span>
    </Tooltip>
  );
};

export default VoicesSyncButton;
